export const STATUSES = {
  NEW: { color: "PICTON_BLUE", hintText: "" },
  READY_TO_PREPARE: { color: "CREAM_CAN", hintText: "" },
  READY_TO_DISPATCH: { color: "BLUE", hintText: "" },
  PREPARING: { color: "VISTA_BLUE", hintText: "" },
  PREPARED: { color: "SEA_GREEN", hintText: "" },
  OUT_FOR_DELIVERY: { color: "GOLDEN_BELL", hintText: "" },
  ON_HOLD: { color: "SCAMPI", hintText: "" },
  PENDING_DELIVERY: { color: "BLUE", hintText: "" },
  DELIVERED: { color: "SEA_GREEN2", hintText: "" },
  PARTIALLY_DELIVERED: { color: "LUCKY", hintText: "" },
  CANCELLED: { color: "DUSTY_GRAY", hintText: "" },
  "RETURNED_TO_STORE/HUB": { color: "JUNGLE_GREEN", hintText: "" },
  DELIVERY_FAILED: { color: "BLACK", hintText: "" },
  PACKING_COMPLETE: { color: "MINSK", hintText: "" },
  ASSIGNED: { color: "BLUE", hintText: "" },
};

export const ROUTE_STATUSES = {
  DRAFTED: { color: "TROPICAL_BLUE", hintText: "" },
  CREATED: { color: "CATSKILL_WHITE", hintText: "" },
  ASSIGNED: { color: "BLUE_HAZE", hintText: "" },
  PREPARING: { color: "BARLEY_WHITE", hintText: "" },
  OUT_FOR_DELIVERY: { color: "DOUBLE_PEARL_LUSTA", hintText: "" },
  COMPLETED: { color: "JAGGED_ICE", hintText: "" },
  PUBLISHED: { color: "TARA", hintText: "" },
  PREPARED: { color: "JAGGED_ICE_PREPARED", hintText: "" },
  CANCELLED: { color: "ALTO", hintText: "" },
};

export const FILTER_CHIPS = [
  { code: "UNPLANNED", value: "Unplanned" },
  { code: "PLANNED", value: "Planned" },
  { code: "PUBLISHED", value: "Published" },
  { code: "PREPARING", value: "Preparing" },
  { code: "PREPARED", value: "Prepared" },
  { code: "OUT_FOR_DELIVERY", value: "Out For Delivery" },
  { code: "COMPLETED", value: "Completed" },
  { code: "ALL", value: "All" },
];

export const TERMINAL_STATUSES = [
  "DELIVERY_FAILED",
  "CANCELLED",
  "DELIVERED",
  "PARTIALLY_DELIVERED",
  "ON_HOLD",
];

export const NON_EDITABLE_STATUSES = [
  "DELIVERY_FAILED",
  "CANCELLED",
  "PARTIALLY_DELIVERED",
  "DELIVERED",
];
export const CANCELLED = "CANCELLED";
export const DEFAULT_FILTER_CHIP = "UNPLANNED";
export const COMPLETED = "COMPLETED";
export const REPLANNING_CONSIGNMENT_SUCCESS_MSG =
  "Consignment updated successfully.";
export const ADDRESS_MARKED_UNVERIFIED =
  "Address has been marked as unverified";
export const DEFAULT_REPLANNING_SELECTION = "reschedule";
export const COD_TEXT = "COD";

export const CREATE_ROUTE_DATA = {
  CREATE_ROUTE_SUCCESS_MSG: "has been created successfully",
  DRAFTED_CONSIGNMENT_TOOLTIP_MSG:
    "This consignment is being used in another route",
  CAPACITY_BREACH_MSGS: {
    CONSIGNMENTS: "You are exceeding capacity for the consignments",
    CRATES: "You are exceeding capacity for the crates",
    TRANSIT_TIME: "You are exceeding capacity for the transit time",
    CONSIGNMENTS_AND_CRATES:
      "You are exceeding capacity for the consignments and crates",
    CONSIGNMENTS_AND_TRANSIT_TIME:
      "You are exceeding capacity for the consignments and transit time",
    CRATES_AND_TRANSIT_TIME:
      "You are exceeding capacity for the crates and transit time",
    ALL_VALUES:
      "You are exceeding capacity for the consignments, crates and transit time",
  },
  DRIVER_SERVICE_TIME: 600,
  TAB_VALUES: {
    UNPLANNED: "unplanned",
    PLANNED: "planned",
  },
};

export const RESPONSE_CONSTANTS = {
  ERROR_CODES: {
    SESSION_TIMEOUT: "UM100",
    UNAUTHORISED: "UM101",
    CONCURRENT_CONSIGNMENT: "CWO15",
  },
};

export const ALL_FILTER_CHIP = "ALL";

export const DEFAULT_FILTER_OBJECT_ROUTE = {
    hub: {
      key: "hub",
      value: [],
      fieldName: "c.hubCode",
    },
    hubName: {
      key: "hubName",
      value: [],
      fieldName: "c.hubCode",
    },
    routeId: {
      key: "routeId",
      value: [],
      fieldName: "c.routeId",
    },
    deliveryArea: {
      key: "deliveryArea",
      value: [],
      fieldName: "c.deliveryArea",
    },
    carrier: {
      key: "carrier",
      value: [],
      fieldName: "c.carrier",
    },
    deliveryProposition: {
      key: "deliveryProposition",
      value: [],
      fieldName: "c.deliveryProposition",
    },
    routeStatus: {
      key: "routeStatus",
      value: [],
      fieldName: "c.status",
    },
    driver: {
      key: "driver",
      value: [],
      fieldName: "c.assignee.id",
    },
    vehicle: {
      key: "vehicle",
      value: [],
      fieldName: "c.assignedVehicle.id",
    },
    helper: {
      key: "helper",
      value: [],
      fieldName: "c.helper.id",
    },
    createdBy: {
      key: "createdBy",
      value: [],
      fieldName: "c.createdBy",
    },
    pageNumber: 0,
    displayRouteStatus: {
      key: "displayRouteStatus",
      value: ["PLANNED"],
      fieldName: "c.displayRouteStatus",
      ignoreCount: true,
    },
    dateRange: {
      key: "dateRange",
      value: {
        startDate: new Date(),
        endDate: new Date(),
      },
    },
    deliverySlot: {
      key: "deliverySlot",
      value: [],
    },
}

export const DEFAULT_FILTERS_OBJ_CONSIGNMENT = {
  hub: {
    key: "hub",
    value: [],
    fieldName: "c.posInformation.store",
  },
  hubName: {
    key: "hubName",
    value: [],
    fieldName: "c.posInformation.store",
  },
  deliveryArea: {
    key: "deliveryArea",
    value: [],
    fieldName: "c.deliveryInformation.customerContactInfo.address.area",
  },
  orderType: {
    key: "orderType",
    value: [],
    fieldName: "c.metadata.category",
  },
  deliveryStatus: {
    key: "deliveryStatus",
    value: [],
    fieldName: "c.metadata.deliveryStatus",
  },
  paymentType: {
    key: "paymentType",
    value: [],
    fieldName: "c.metadata.paymentType",
  },
  carrier: {
    key: "carrier",
    value: [],
    fieldName: "c.deliveryInformation.carrier",
  },
  deliveryProposition: {
    key: "deliveryProposition",
    value: ["STD"],
    fieldName: "c.metadata.deliveryType",
    ignoreCount: true,
  },
  routeId: {
    key: "routeId",
    value: [],
    fieldName: "c.metadata.routeId",
  },
  routeStatus: {
    key: "routeStatus",
    value: [],
    fieldName: "c.metadata.routeStatus",
  },
  driver: {
    key: "driver",
    value: [],
    fieldName: "c.deliveryInformation.driver.id",
  },
  
  vehicle: {
    key: "vehicle",
    value: [],
    fieldName: "c.deliveryInformation.vehicle.id",
  },
  helper: {
    key: "helper",
    value: [],
    fieldName: "c.deliveryInformation.helper.id",
  },
  deliveryFailedReason: {
    key: "deliveryFailedReason",
    value: [],
    fieldName: "c.reason.reasonCode",
  },
 
  pageNumber: 0,
  displayRouteStatus: {
    key: "displayRouteStatus",
    value: ["UNPLANNED"],
    fieldName: "c.metadata.displayRouteStatus",
    ignoreCount: true,
  },
  dateRange: {
    key: "dateRange",
    value: {
      startDate: new Date(),
      endDate: new Date(),
    },
  },
  deliverySlot: {
    key: "deliverySlot",
    value: [],
  },
};

export const SEARCH_TYPES = [
  {
    name: "Consignment Id",
    value: "c.consignmentCode",
  },
  {
    name: "Order Id",
    value: "c.orderCode",
  },
  {
    name: "Crate Id",
    value: "c.crateId",
  },
  {
    name: "Phone",
    value: "c.deliveryInformation.customerContactInfo.phone",
  },
  {
    name: "Full Name",
    value: "c.deliveryInformation.customerContactInfo.name",
  },
  {
    name: "Email",
    value: "c.deliveryInformation.customerContactInfo.email",
  },
]

export const  SORT_MODAL = {
  field: "deliveryDate",
  direction: "asc",
}

export const DISPLAY_ROUTE_STATUS_FILTER_OBJ_ROUTE= {
  key: "displayRouteStatus",
  value: ["PLANNED"],
  fieldName: "c.displayRouteStatus",
  ignoreCount: true,
}

export const DISPLAY_ROUTE_STATUS_FILTER_OBJ_ORDER = {
  key: "displayRouteStatus",
  value: ["UNPLANNED"],
  fieldName: "c.metadata.displayRouteStatus",
  ignoreCount: true,
}